import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  background: ${({ theme }) => theme.colors.gray[100]};
  box-shadow: ${({ theme }) => theme.shadow.default};
  border-radius: 8px;

  margin-top: 32px;
`;

export const TableTitle = styled.div`
  display: flex;
  justify-content: center;
  width: 98%;
  background: ${({ theme }) => theme.colors.orange.primary};

  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.14), 0 1px 10px rgba(0, 0, 0, 0.12),
    0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 8px;

  font-weight: 600;
  font-size: 18px;

  padding: 12px;

  color: ${({ theme }) => theme.colors.white};

  margin: -24px auto 0;
`;

export const Body = styled.div`
  display: flex;
`;

export const Table = styled.div`
  width: 100%;

  h6 {
    font-weight: 500;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.gray[600]};

    padding: 8px 24px;
  }

  div {
    display: grid;
    grid-template-columns: 1fr 1fr;

    padding: 8px 24px;

    p {
      font-weight: 400;
      font-size: 12px;
      color: ${({ theme }) => theme.colors.gray[600]};
    }

    &:nth-child(even) {
      background-color: ${({ theme }) => theme.colors.gray[200]};
    }

    &:last-child,
    &:nth-last-child(2) {
      p {
        font-weight: 700;
      }
    }
  }

  & + & {
    border-left: 1px solid ${({ theme }) => theme.colors.gray[400]};
  }
`;

export const Footer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.gray[400]};

  display: flex;
  gap: 65px;
  justify-content: flex-end;

  padding: 8px 164px;
  background-color: ${({ theme }) => theme.colors.gray[200]};

  border-radius: 0px 0px 8px 8px;

  p {
    font-weight: 700;
    font-size: 14px;

    color: ${({ theme }) => theme.colors.orange.primary};
  }
`;
